import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 10000 }
  }

  connect() {
    this.loading = false
    this.element.addEventListener("turbo:frame-missing", this.onFrameMissing)
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad)
    this.element.addEventListener("turbo:fetch-request-error", this.onFrameLoad)
    // Initial turbo-frame src fetch is in flight on connect.
    if (this.element.hasAttribute("src")) this.loading = true
    this.timer = setInterval(() => this.reloadFrame(), this.intervalValue)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-missing", this.onFrameMissing)
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad)
    this.element.removeEventListener("turbo:fetch-request-error", this.onFrameLoad)
    if (this.timer) clearInterval(this.timer)
  }

  onFrameLoad = () => {
    this.loading = false
  }

  onFrameMissing = (event) => {
    event.preventDefault()
    this.loading = false
    this.showError("Dashboard panel failed to load. Retrying…")
    setTimeout(() => this.reloadFrame(), 3000)
  }

  showError(message) {
    if (this.element.querySelector(".Banner--error")) return
    this.element.innerHTML = `<div class="Banner Banner--error p-3 f6">${message}</div>`
  }

  reloadFrame() {
    const src = this.element.getAttribute("src")
    if (!src || this.loading) return

    this.loading = true
    const url = new URL(src, window.location.origin)
    url.searchParams.set("t", Date.now().toString())
    this.element.src = url.toString()
  }
}
